<template>
  <div class="all-group-classes">
    <all-group-classes-card />
  </div>
</template>

<script>
import AllGroupClassesCard from '../cards/AllGroupClassesCard'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'all-group-classes',
  components: {
    AllGroupClassesCard,
  },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/services/group-class',
      ogTitle: 'Group Classes - Rewarding Dog Training',
      ogDescription: 'Group classes are a great option to train on a budget. Join our many class options to help strengthen your dog\'s attention and bond to you.',
    })
  },
}
</script>

<style lang="scss">
.all-group-classes {
  width: 100%;
}
</style>
